module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "ml-2",
    staticStyle: {
      "min-height": "150px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "150px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "mr-2 text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "130px",
      "border-radius": "15px",
      "border": "1px solid black",
      "overflow": "hidden",
      "background-color": "#d1d1d1"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "overflow-y": "hidden",
      "width": "100%"
    },
    attrs: {
      "src": _vm.group.coverPhoto.url
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4 pl-4",
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "xs7": ""
    }
  }, [(_vm.canAccessGroup) ? _c('h6', {
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo(("" + (_vm.group.groupId)))
      }
    }
  }, [_vm._v(_vm._s(_vm.group.name))]) : _c('h6', {
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAlert.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.group.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("group")]), _vm._v("  " + _vm._s(Object.keys(_vm.groupMembers).length) + " Members\n        ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": "",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.joinGroup(_vm.group)
      }
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n              Join \n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "20%"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("share")]), _vm._v("\n            Share\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "my-2"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e491d9d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupViewComponent.vue
// module id = 1730
// module chunks = 30